import useFetch from '@e3dc-react/shell/Hooks/useFetch'
import React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { useActiveInstallation } from 'src/Hooks'
import { useInstallationPageHandler } from 'src/Hooks/use-installation-page-handler'
import { Installation } from 'src/Libs/installations/models'
import VehicleIntegrationRoute from 'src/Routes/P3_eMobility/VehicleIntegrationRoute'
import { VehiclesLoading } from './loading'

const VehicleIntegrationMainPage: React.FC = () => {
  const { installationId } = useParams<{ installationId: string; storageId: string }>()
  if (!installationId) throw new Error('Installation ID is required')

  useInstallationPageHandler('emobility.header.vehicle-integration-title')

  const [installation, installationLoading] = useFetch<Installation>({
    url: `installations/${installationId}`,
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    doNotFetch: !installationId,
    retryOnFailure: false,
  })

  const storageId = installation?.emsMasterDeviceId
  useActiveInstallation(true, installationId, storageId ?? '')

  if (installationLoading) {
    return <VehiclesLoading />
  }

  return (
    <Routes>
      <Route path={`/*`} element={<VehicleIntegrationRoute installationId={installationId} />} />
    </Routes>
  )
}

export default VehicleIntegrationMainPage
